module.exports = __webpack_public_path__ + "static/media/count-days-clock.524327e6.svg";